<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
    <div class="text-v-ui-gray-900 text-[20px] font-semibold leading-[120%]">
      Тип КЗС и алгоритм
    </div>

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Тип КЗС
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsType }}</div>
    </div>

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Алгоритм
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.algorithm.algorithmName }}</div>
    </div>
    <!-- End form item -->

        <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]" v-for="field in kzsData.algorithm.formConfig?.fields" :key="field.name">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        {{ field.label }}
      </div>
      <div class="massive-16-reg text-secondary">{{ generateFieldValue(field) }}</div>
    </div>
    <!-- End form item -->
  </div>
</template>

<script>

export default {
  name: 'KzsViewAlgoSettings',
  props: {
    kzsData: {
      type: Object,
      required: false,
    },
  },

  computed: {
    kzsType() {
      const map = {
        0: 'Тревожный',
        1: 'Успешный',
      };
      return map[this.kzsData.type] || 'Неизвестно';
    },
  },

  methods: {
    getParamValueByPath(fieldName) {
      const params = this.kzsData?.algorithm?.params;
      if (!params || !fieldName) return undefined;

      return fieldName.split('.').reduce((acc, key) => {
        if (acc && typeof acc === 'object') {
          return acc[key];
        }
        return undefined;
      }, params);
    },
    generateFieldValue(field) {
      const value = this.getParamValueByPath(field.name);

      if (field.type === 'number') {
        return value ?? 'Неизвестно';
      }

      if (field.type === 'select') {
        const options = field.options;
        return value.map(v => options.find(o => o.value == v)?.label).join(', ') || 'Неизвестно';
      }

      return 'Неизвестно';
    }
  },
}

</script>
